export default {
    props: {
        loading: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        toggleLoading(toggle = null) {
            if (toggle == null)
                return (this.mutableLoading = !this.mutableLoading);

            return (this.mutableLoading = toggle);
        }
    },
    watch: {
        search() {
            this.$emit("search", this.search, this.toggleLoading);
        },
        loading(val) {
            this.mutableLoading = val;
        }
    },
    data() {
        return {
            mutableLoading: false
        };
    }
};
